import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { pick } from 'lodash'

import { useQueryParams } from '../../core/hooks'

import { DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS } from '../constants'
import { updateBrandCurationTasksPersistedFilters } from '../redux/actions'

const useBrandCurationTasksListFilters = () => {
  const persistedFilters = useSelector(
    store => store.brandCurationTasks.brandCurationTasks.persistedFilters,
  )
  const dispatch = useDispatch()

  const {
    currentPage,
    pageSize,
    taskStatus = persistedFilters?.taskStatus ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.TASK_STATUS,
    isCurationDone = persistedFilters?.isCurationDone ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.IS_CURATION_DONE,
    isQaDone = persistedFilters?.isQaDone ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.IS_QA_DONE,
    isQcDone = persistedFilters?.isQcDone ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.IS_QC_DONE,
    autoeatStatus = persistedFilters?.autoeatStatus ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.AUTOEAT_STATUS,
    searchText = DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.SEARCH,
    assignedCurator = persistedFilters?.assignedCurator ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.ASSIGNED_CURATOR,
    assignedQa = persistedFilters?.assignedQa ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.ASSIGNED_QA,
    assignedQc = persistedFilters?.assignedQc ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.ASSIGNED_QC,
    duplicate = persistedFilters?.duplicate ||
      DEFAULT_BRAND_CURATION_TASK_LIST_FILTERS.DUPLICATE,

    setQueryParams,
  } = useQueryParams()

  const setFilters = useCallback(
    value => {
      dispatch(
        updateBrandCurationTasksPersistedFilters({
          ...persistedFilters,
          ...pick(value, [
            'taskStatus',
            'isCurationDone',
            'isQaDone',
            'isQcDone',
            'autoeatStatus',
            'assignedCurator',
            'assignedQa',
            'assignedQc',
            'duplicate',
          ]),
        }),
      )

      setQueryParams(value)
    },
    [dispatch, persistedFilters, setQueryParams],
  )

  return {
    currentPage,
    pageSize,
    taskStatus,
    isCurationDone,
    isQaDone,
    isQcDone,
    autoeatStatus,
    assignedCurator,
    assignedQa,
    assignedQc,
    duplicate,
    searchText,
    setFilters,
  }
}

export default useBrandCurationTasksListFilters
